const toCount = (value, fieldName) => {
  const count = Number(value)

  if (!Number.isSafeInteger(count) || count < 0) {
    throw new TypeError(`${fieldName} must be a non-negative integer`)
  }

  return count
}

const toMinorUnitString = (value, fieldName) => {
  if (value === null || value === undefined || value === "") {
    throw new TypeError(`${fieldName} must be an integer string`)
  }

  try {
    return window.BigInt(value).toString()
  } catch {
    throw new TypeError(`${fieldName} must be an integer string`)
  }
}

export const mapWalletSummaryResponse = (response) => {
  const data = response?.data?.summary

  if (!data || typeof data !== "object") {
    throw new TypeError("Wallet summary response is missing data")
  }

  return {
    totalVendors: toCount(data.totalVendors, "totalVendors"),
    totalWalletBalanceMinor: toMinorUnitString(
      data.totalWalletBalanceMinor,
      "totalWalletBalanceMinor",
    ),
    currency: data.currency,
  }
}

export const formatMinorUnits = (value) => {
  const amount = window.BigInt(value)
  const sign = amount < 0n ? "-" : ""
  const absolute = amount < 0n ? -amount : amount
  const rupees = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(absolute / 100n)
  const paise = (absolute % 100n).toString().padStart(2, "0")

  return `${sign}₹${rupees}.${paise}`
}
